import { useEffect, useRef, useState } from 'react';
import { const_var } from '../../redux/reducers/reducer.js';
import SaveButtonFunction from '../ControlPanel/Common/SaveButton.js';
import { useDispatch } from 'react-redux';
import { CheckCaptureModalImage } from '../../action/extra_options/orderExtras.action.js';
import { handleSaveLatter } from '../../action/quote_order/quote.action.js';
import { handleCommonModal } from '../../action/quote_order/leadcustomer.action.js';
import { downloadOnClick, prepareTwoDMapData } from "../../action/2d_mapping/twoDMap.action.js";
import { ShowMeasure } from "../../action";
import OrderNow from '../ControlPanel/Common/OrderNow.js';
function SlideBottom() {
    const [showTooltip, setShowTooltip] = useState();

    const dispatch = useDispatch()
    const onSaveClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        //autoGeneratedPDF();
        if (const_var.callMesure) {
            dispatch(ShowMeasure("save"))
          }
    };

    
    let orderNowInitialCheck = const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false && const_var.stateData && const_var.stateData.hide_price_calculation == 0 &&  (const_var.crmSetting.is_show_cta == true || const_var.crmSetting.is_show_cta == undefined);

    let orderNowOtherCheck = const_var.crmSetting.is_module_name === "inventory" || (const_var.isPublicEdit==true && const_var.crmSetting.is_quote_Edit==true || const_var.isPublicEdit==true)

    return (
        <>
            {const_var.crmSetting.is_show_cta == true || const_var.crmSetting.is_show_cta == undefined ?
                <div className='bottom-bar'>
                    {
                        const_var.loginSession === false && const_var.crmSetting.main_domain_url == "keensbuildings.com" &&
                        <div className='finance-container'>
                            <div className='finance-title-container' onMouseOver={(e) => setShowTooltip(true)} onMouseOut={(e) => setShowTooltip(false)} onClick={(const_var.crmSetting.form_action == "edit" &&
                                        const_var.i_g_A_y.length > 0)
                                        ?
                                        (e) => {
                                            dispatch(CheckCaptureModalImage('open'));
                                            onSaveClick();
                                        }
                                        :
                                        (const_var.loginSession == false)
                                        ?
                                        (e) => {
                                            dispatch(handleSaveLatter('open'));
                                            onSaveClick();
                                        }
                                        :
                                        (e) => {
                                            dispatch(handleCommonModal('lead_customer', 'save'));
                                            onSaveClick();
                                        }
                                    }>
                                <span className='d-flex'>
                                    <i className='icon-subscription-ico'></i>
                                </span>
                                <span class='finance-title'>
                                    View Financing Offers
                                </span>
                            </div>
                            {
                                showTooltip &&
                                <div className='finance-tooltip finance-tooltip-show'>
                                    <ul className='list-item'>
                                        <li>$0 Down Financing</li>
                                        <li>Interest Free (Same as Cash)</li>
                                        <li>Rent to Own (No Credit Check)</li>
                                    </ul>
                                </div>
                            }
                        </div>
                    }
                    {orderNowInitialCheck ?
                        <>
                            {const_var.loginSession === false ? (
                            orderNowOtherCheck ? (
                                <SaveButtonFunction class_name={const_var.is_loader == false? "btn btn-block btn-primary btn-share" : "btn btn-block btn-primary btn-share disabled"}/>
                            ) : (
                            <div className="sidebar-bottom-btn">
                                <OrderNow
                                    title="Order now"
                                    i_g_A_y={const_var.i_g_A_y}
                                    order_now={const_var.crmSetting.order_now}
                                    is_quote_Edit={const_var.crmSetting.is_quote_Edit}
                                    form_action={const_var.crmSetting.form_action}
                                    is_loggedin={const_var.loginSession}
                                />
                            </div>
                            )
                        ) : null}
                        </> : 
                        <SaveButtonFunction class_name={const_var.is_loader == false? "btn btn-block btn-primary btn-share" : "btn btn-block btn-primary btn-share disabled"}/>
                    }
                </div>
              :null
            }
        </>
    )
}

export default SlideBottom